/*
 * =============================================================================
 * Project: payments.telestrada-online.pl
 * Created Date: 2018-07-11, 17:05:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-07-17, 09:39:41
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

/* Vuex store */
import Vue from 'vue';
import Vuex from 'vuex';

// MODULES /////////////////////////////////////////////////////////////////////
import App from './modules/App';
import Payment from './modules/Payment';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    App, Payment,
  },
  strict: !process.env.DEBUG_MODE,
});



// WEBPACK FOOTER //
// ./src/store/index.js